import { type RefCallback, useCallback, useRef, useState } from 'react'

export const useElementHeight = <T extends HTMLElement>(): { ref: RefCallback<T>; height: number } => {
  const observerRef = useRef<ResizeObserver | null>(null)
  const [height, setHeight] = useState(0)

  const ref = useCallback((node: T | null): void => {
    observerRef.current?.disconnect()
    observerRef.current = null

    if (!node) return

    const updateHeight = (): void => {
      const nextHeight = node.offsetHeight
      setHeight((current) => (current === nextHeight ? current : nextHeight))
    }

    updateHeight()

    const observer = new ResizeObserver(updateHeight)
    observer.observe(node)
    observerRef.current = observer
  }, [])

  return { ref, height }
}
